const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/GoBackToDashboardButton.tsx';
import React from 'react';
import { Button, Icon } from '@mui/material';
import { css } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';
import textMap from './translations';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { goToDashboard } from 'App/utils/history';

type Props = {};

const backBtnStyle = css`
    margin-bottom: ${theme.spacing(1.8)} !important;
    color: ${theme.palette.primary.main} !important;
    padding: ${theme.spacing(1)} !important;
`;

const GoBackToDashboardButton = (props: Props) => {
    const { formatMessage } = useIntl();
    const history = useHistory();

    return (
        <Button
            variant={'text'}
            className={backBtnStyle}
            startIcon={<Icon className={'icons8-chevron-left'} />}
            onClick={() => goToDashboard(history)}
        >
            {formatMessage(textMap.backToStartButton)}
        </Button>
    );
};

export default GoBackToDashboardButton;
